<div class="container-fuild subTask-container">
  <form (ngSubmit)="postSubTask()" #subtaskForm="ngForm" class="update-subtask-details-form"> 
    <p-tabView [(activeIndex)]="index" class="taskAllocation-tab" (onChange)="handleChange($event)">
      <p-tabPanel>
        <ng-template pTemplate="header">
          <div class="row">
            <span class="header-icon border rounded-circle p-3">
              <i>1</i>
            </span>
            <hr style="width: 34%;position: absolute;top: 2rem;right:0" />
          </div>
          <label>Task Details</label>
        </ng-template>

        <div class="row col-md-12 mb-4 subTask-title">
          <div class="col-md-10">
            <h5>Sub Task Details</h5>
          </div>
          <div class="col-md-2 icons-title">
            <!-- <span class="pi pi-trash"> Delete  </span> -->
            <span class="pi pi-times" (click)="handleSubTaskPanelToggle()"></span>
          </div>
        </div>

        <div class="row" *ngIf="task?.serviceCenterDetails">
          <div class="col-md-4 form-group">
            <label class="label-cls row"> Processing Type</label>
            <p-radioButton #processingType="ngModel" name="processingType" (onClick)="onChangeProcessingType(0)" value="0"
              class="mr-2" label="Regular" [(ngModel)]="task.serviceCenterDetails.isPremiumCenter"
              [disabled]="!isOutsideImagility || disabledControls"></p-radioButton>
            <p-radioButton #processingType="ngModel" name="processingType" (onClick)="onChangeProcessingType(1)" value="1"
              class="mr-2" label="Premium" [(ngModel)]="task.serviceCenterDetails.isPremiumCenter"
              [disabled]="!isOutsideImagility || disabledControls"></p-radioButton>
            <span class="invalid-message"
              *ngIf="(processingType.touched || subtaskForm.submitted) && processingType.errors?.required">
              {{getGlobalErrorMessages('REQUIRED')}}
            </span>
          </div>
          <div class="col-md-4 form-group processing-dropdown">
            <label class="label-cls row"> Select Service Centre </label>
            <p-dropdown appendTo="body" [options]="serviceCenterList" [(ngModel)]="task.serviceCenterDetails.id"
              #serviceCenter="ngModel" name="serviceCenter" optionLabel="name" optionValue="id"
              placeholder="Select Service center" [disabled]="disabledControls" required>
            </p-dropdown>
            <span class="invalid-message"
              *ngIf="(serviceCenter.touched || subtaskForm.submitted) && serviceCenter.errors?.required">
              {{getGlobalErrorMessages('REQUIRED')}}
            </span>
          </div>
        </div>
    
        <div class="row  pt-4" *ngIf="task.signatoryDetails">
          <div class="col-md-4 form-group processing-dropdown">
            <label class="label-cls row"> Signatory Name</label>
            <p-dropdown appendTo="body" [options]="signatoryEmployeeList" [(ngModel)]="task.signatoryDetails.id"
              name="authorizedSignatory" #authorizedSignatory="ngModel" optionValue="id" placeholder="Select Signatory"
              optionLabel="firstName" required (onChange)="onSignatoryChange($event)" [disabled]="disabledControls">
              <ng-template pTemplate="selectedItem">
                <div *ngIf="task.signatoryDetails.id">
                  <div>{{task.signatoryDetails?.firstName + ' ' + task.signatoryDetails?.lastName}}</div>
                </div>
              </ng-template>
              <ng-template let-employee pTemplate="item">
                <div>
                  <div>{{employee?.firstName +' '+employee?.lastName}}</div>
                </div>
              </ng-template>
            </p-dropdown>
            <span class="invalid-message"
              *ngIf="(authorizedSignatory.touched || subtaskForm.submitted) && authorizedSignatory.errors?.required">
              {{getGlobalErrorMessages('REQUIRED')}}
            </span>
          </div>
          <div class="col-md-4 form-group processing-dropdown">
            <label class="label-cls row"> Designation </label>
            <input type="text" class="im-input mw-100" readOnly name="selectedDesignation" [disabled]="disabledControls"
              [(ngModel)]="task.signatoryDetails.designation" pInputText />
          </div>
        </div>
    
        <div class="row  pt-4">
          <div class="col-md-4 form-group processing-dropdown">
            <label class="label-cls row"> Lawfirm</label>
            <p-dropdown appendTo="body" [options]="attorneyFirmList" [(ngModel)]="task.attorneyId" name="attorney"
              #attorney="ngModel" optionLabel="attorneyName" optionValue="attorneyId" (onChange)="onAttorneyFirmChange()"
              placeholder="Select lawfirm" [disabled]="disabledControls" required>
            </p-dropdown>
            <span class="invalid-message" *ngIf="(attorney.touched || subtaskForm.submitted) && attorney.errors?.required">
              {{getGlobalErrorMessages('REQUIRED')}}
            </span>
          </div>
          <div class="col-md-4 form-group processing-dropdown">
            <label class="label-cls row"> Preparer Name </label>
            <p-dropdown appendTo="body" [options]="attorneyPreparerEmployeeList" [(ngModel)]="task.preparerAttorneyId"
              name="preparerAttorney" #preparerAttorney="ngModel" optionLabel="firstName" optionValue="id"
              placeholder="Select Preparer" (onChange)="onAttorneyPreparerChange($event)" [disabled]="disabledControls"
              required>
              <ng-template pTemplate="selectedItem">
                <div *ngIf="task.preparerAttorneyId">
                  <div>{{task?.preparerAttorneyName}}</div>
                </div>
              </ng-template>
              <ng-template let-employee pTemplate="item">
                <div>
                  <div>{{employee?.firstName + ' '+ employee?.lastName }}</div>
                </div>
              </ng-template>
            </p-dropdown>
            <span class="invalid-message"
              *ngIf="(preparerAttorney.touched || subtaskForm.submitted) && preparerAttorney.errors?.required">
              {{getGlobalErrorMessages('REQUIRED')}}
            </span>
          </div>
        </div>
        <div class="row  pt-4">
          <div class="col-md-4 form-group processing-dropdown">
            <label class="label-cls row"> Petitioner Preparer Information</label>
            <p-dropdown appendTo="body" [options]="petitionerPreparerEmployeeList" [(ngModel)]="task.immSpecialistId"
              name="immSpecialist" optionLabel="firstName" optionValue="id" #immSpecialist="ngModel"
              placeholder="Select Petitioner Preparer" (onChange)="onPetitionerPreparerChange($event)"
              [disabled]="disabledControls" required>
              <ng-template pTemplate="selectedItem">
                <div *ngIf="task.immSpecialistId">
                  <div>{{task.preparePetitionerName}}</div>
                </div>
              </ng-template>
              <ng-template let-employee pTemplate="item">
                <div>
                  <div>{{employee?.firstName +' '+employee?.lastName}}</div>
                </div>
              </ng-template>
            </p-dropdown>
            <span class="invalid-message"
              *ngIf="(immSpecialist.touched || subtaskForm.submitted) && immSpecialist.errors?.required">
              {{getGlobalErrorMessages('REQUIRED')}}
            </span>
          </div>
        </div>

        <div class="row pt-4 pb-4">
          <div class="col-md-1">
            <button pButton type="button" class="ml-3 p-button-primary" label="Next" title="Next"
              (click)="stepStepTime()" [disabled]="subtaskForm.invalid  || disabledControls"></button>
          </div>
          <div class="col-md-2">
            <button pButton type="button" label="Cancel" icon="pi pi-times-circle" class="p-button-secondary cancel-btn button-width-icon-left 
        d-flex alogn-items-center" [disabled]="disabledControls" (click)="handleSubTaskPanelToggle()">
            </button>
          </div>
        </div>
        
      </p-tabPanel>

      <p-tabPanel [disabled]="subtaskForm.invalid  || disabledControls ">
        <ng-template pTemplate="header">
          <div class="row">
            <hr style="width: 42%;position: absolute;top: 2rem;" />
            <span class="header-icon border rounded-circle p-3">
              <i>2</i>
            </span>
          </div>
          <label>Task Allocation</label>
        </ng-template>
        <ng-template pTemplate="content">
          <app-step-task-allocation [parentFormGroup]="null" [taskObj]="task"></app-step-task-allocation>

          <div class="row pt-4 pb-4">
            <div class="col-md-1">
              <button pButton type="button" class="p-button-secondary mr-3" label="Back" title="Back"
                (click)="index = 0"></button>
            </div>
            <div class="col-md-1 mr-3">
              <button pButton type="submit" label="Save" icon="pi pi-save"
                [ngClass]="subtaskForm.invalid  || disabledControls ? 'btn-success button-width-icon-left mr-3 btn-success_disabled save-btn':'btn-success button-width-icon-left mr-3'"
                [disabled]="subtaskForm.invalid  || disabledControls"></button>
            </div>
            <div class="col-md-2">
              <button pButton type="button" label="Cancel" icon="pi pi-times-circle" class="p-button-secondary cancel-btn button-width-icon-left 
      d-flex alogn-items-center" [disabled]="disabledControls" (click)="handleSubTaskPanelToggle()">
              </button>
            </div>
          </div>
        </ng-template>
      </p-tabPanel>
    </p-tabView>

  </form>
</div>